module.exports = {
	"name": "Anthromes",
	"desc": "The global ecological patterns created by sustained direct human interactions with ecosystems.",
	"useHighResMaps": true,
	"maps": [
		{
			"name": "a1700",
			"displayName": "1700"
		},
		{
			"name": "a1800",
			"displayName": "1800"
		},
		{
			"name": "a1900",
			"displayName": "1900"
		},
		{
			"name": "a2000",
			"displayName": "2000"
		}
	],
	"legendCells": [
		{
			"name": "Dense Settlements",
			"style": "dense-settlements",
			"desc": "Areas of high human population densities and intense urban land use.  This anthrome is usually associated with high nitrogen and carbon emissions, and biodiversity is dominated by introduced species."
		},
		{
			"name": "Villages",
			"style": "villages",
			"desc": "Areas of rural human populations, towns, and small cities with intensive agriculture. Most food produced in this anthrome is consumed locally."
		},
		{
			"name": "Croplands",
			"style": "croplands",
			"desc": "Cultivated lands that include low human population density. This anthrome includes large areas that are cultivated to support humans living elsewhere in dense settlements and villages."
		},
		{
			"name": "Rangelands",
			"style": "rangelands",
			"desc": "Areas used primarily for livestock grazing, but may also support a modest human population density."
		},
		{
			"name": "Seminatural",
			"style": "seminatural",
			"desc": "Areas with a relatively low level of human land use (<20% of land used for crops, pasture, or urban settlements)."
		},
		{
			"name": "Wildlands",
			"style": "wildlands",
			"desc": "Land without human population or agriculture. However, wildlands are still subject to regional, human-caused changes, such as climate change and the spread of invasive species."
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/resources/data/anthrome-info.json
// module id = 1150
// module chunks = 0